const vueInst = new Vue({
	el: '#vue-wrap',
	data: {
	    mName: '',
	    mid: null,
		user: {},
        page: 1,
		rows: 12,
        totalPage: 1,
        isOver: 0,
		list: [],
        emptyFlag: false,
        courseList: [],
        course: {
		    id: null,
            dycid: 0,
            course_name: '不限'
        },
        courseFlag: false
	},
	methods: {
        getName: function(name) {
            this.mName = name;
        },
        getParams: function() {
            this.mid = this.getQueryString('mid') - 0 || 11;
            this.page = this.getQueryString('page') - 0 || 1;
            this.isOver = this.getQueryString('over') - 0 || 0;
        },
        // 获取科目
        getCourseList: function() {
            axios.post(baseURL + 'getCourseByMid?mid=' + this.mid)
                .then(res => {
                    if (res.code == 200) {
                        res.list.unshift(this.course);
                        this.courseList = res.list;
                    }
                })
                .catch(err => console.log(err));
       
        },
        changeCourse: function (course) {
		    console.log(course)
            if (this.course.id == course.id) return

            this.course = course;

            if(this.mid==11 || this.mid==71){
                this.getNewList()
            }else{
                this.getList();
            }
        },
        getList: function() {
            this.emptyFlag = false;
            this.list.length = 0;

            let cid = this.course.id;
            if (this.mid == 71 || this.mid == 91) {
                cid = this.course.dycid;
            }

            axios.post(baseURL + 'getAnnounce?page=' + this.page
                + '&rows=' + this.rows
                + '&mid=' + this.mid
                + '&is_over=' + this.isOver
                + '&cid=' + cid)
                .then(res => {
                    if (res.code == 200) {
                        if (res.list.length == 0) {
                            this.emptyFlag = true;
                        }

                        res.list.forEach(item => {
                            const reg = new RegExp( '-' , 'g' )
                            const startTime = new Date(item.start_time.replace(reg, '/'));
                            const currentTime = new Date(item.currentime.replace(reg, '/'));
                            const startYear = startTime.getFullYear();
                            const currentYear = currentTime.getFullYear();
                            const startMonth = startTime.getMonth();
                            const currentMonth = currentTime.getMonth();
                            const startDate = startTime.getDate();
                            const currentDate = currentTime.getDate();

                            item.start = startTime.getTime() - currentTime.getTime() < 0;

                            item.time = item.start_time.split(' ')[1].split(':')[0] + ':' + item.start_time.split(' ')[1].split(':')[1]

                            if (startYear == currentYear && startMonth == currentMonth && startDate == currentDate) {
                                item.date = '今天'
                            } else if (startYear == currentYear && startMonth == currentMonth && startDate - currentDate > 0 && startDate - currentDate < 2) {
                                item.date = '明天'
                            } else {
                                item.date = item.start_time.split(' ')[0].split('-')[1] + '月' + item.start_time.split(' ')[0].split('-')[2] + '日 ' + this.getDay(startTime.getDay())
                            }
                        });
                        this.list = res.list;

                        this.totalPage = Math.ceil(res.total / this.rows);
                    }
                })
                .catch(err => console.log(err));
        },
        getNewList: function() {
            let formData = {
				page: this.page,
                size:this.rows,
                subjectTypeId:this.course.id ,
				type: this.isOver + 1,
			}
			request.post('/api/edu/teaching/video/recentLive', formData).then(res => {
                // console.log(res,'res')
				let list = res.data.records || [];
                let total = res.data.total;
                
                if (list.length == 0) {
                    this.emptyFlag = true;
                }else{
                    this.emptyFlag = false;
                }
                this.list = list;
                this.totalPage = Math.ceil(total / this.rows);
			})
        },
        getNewCourseList(){
            let majorId = null;
            if(this.mid==11){
                majorId = 1;
            }else if (this.mid==71){
                majorId = 2;
            }
            let formData = {
                majorId
            }
            request.post('/api/edu/teaching/subjectType/getList',formData).then(res => {
                let list = res.data || [];
                for (let i = 0; i < list.length; i++) {
                    let item = list[i];
                    item.course_name = item.name;
                }
                list.unshift(this.course)
                this.courseList = list;
            })
        },
        changeLiveType: function (type) {
            if (this.isOver === type) return
            this.isOver = type;
            this.totalPage = this.page = 1;
            if(this.mid==11 || this.mid==71){
                this.getNewList()
            }else{
                this.getList();
            }
        },
        //分页
        turnPage: function(page) {
            this.page = page;
            if(this.mid==11 || this.mid==71){
                this.getNewList()
            }else{
                this.getList();
            }
        },
        goLive: function (item) {
   
            if(this.mid==11 || this.mid==71){
                window.location.href = 'pages/live/video.html?id=' + item.liveVideoId +'&structureId='+item.structureId
            }else{
                if (item.is_over) {
                    if (item.url) {
                        // window.open('pages/live/play.html?id=' + item.id);
                        // window.open(item.url);
                        window.location.href = item.url
                    } else {
                        alert('回放生成中，请学习其它课程')
                    }
                } else {
                    // window.open('pages/live/live.html?id=' + item.id);
                    window.location.href = 'pages/live/live.html?id=' + item.id
                }
            }
 
        }
	},
    mounted: function () {
        this.getParams();
        if(this.mid==11 || this.mid==71){
            this.getNewList()
            this.getNewCourseList();
        }else{
            this.getCourseList();
            this.getList();
        }
    }
});